import PropTypes from "prop-types"
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"

import Button from "src/components/Button"
import Tabs from "src/components/Tabs"

import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

import AuditLog from "./AuditLog"
import LaunchesByBoatReport from "./LaunchesByBoatReport"
import LaunchesByLocationReport from "./LaunchesByLocationReport"

const TAB_NAMES = ["audit-log", "location", "boat"]

const LaunchReports = ({ trackingProps }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const marinaSlug = getCurrentMarinaSlug()

  const urlParams = new URLSearchParams(location.search)
  const tabFromParams = urlParams.get("tab")
  const currentTab =
    TAB_NAMES.indexOf(tabFromParams) >= 0 ? TAB_NAMES.indexOf(tabFromParams) : 0

  const handleTabChange = (tabIndex) => {
    const params = new URLSearchParams()
    params.set("tab", TAB_NAMES[tabIndex])
    navigate(`?${params.toString()}`)
  }

  return (
    <div className="container px-0 lg:px-4 lg:pt-8">
      <div className="my-2 flex flex-col items-center lg:my-0 lg:flex-row-reverse">
        <div className="h-10">
          <Button variant="ghost" onClick={() => navigate("/")}>
            Back to Launches
          </Button>
        </div>
      </div>
      <Tabs selectedIndex={currentTab} onChange={handleTabChange}>
        <div className="flex w-full flex-col justify-between lg:flex-row">
          <div className="order-2 flex justify-center border-b lg:order-1 lg:border-none">
            <Tabs.TabList>
              <Tabs.Tab title="Audit Log" />
              <Tabs.Tab title="Launches by Location" />
              <Tabs.Tab title="Launches by Boat" />
            </Tabs.TabList>
          </div>
        </div>
        <Tabs.Panels>
          <Tabs.Panel>
            <AuditLog marinaSlug={marinaSlug} />
          </Tabs.Panel>{" "}
          <Tabs.Panel>
            <LaunchesByLocationReport trackingProps={trackingProps} />
          </Tabs.Panel>
          <Tabs.Panel>
            <LaunchesByBoatReport trackingProps={trackingProps} />
          </Tabs.Panel>
        </Tabs.Panels>
      </Tabs>
    </div>
  )
}

LaunchReports.propTypes = {
  trackingProps: PropTypes.shape({
    marina_id: PropTypes.string.isRequired,
    marina_name: PropTypes.string.isRequired,
  }),
}

export default LaunchReports
